import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import Spinner from '~/components/Spinner';

import { selectError, selectInterview, selectLoading } from './selectors';

const Interview = props => {
  const { interview, render } = props;
  return <Spinner {...props}>{interview && render(interview)}</Spinner>;
};

Interview.propTypes = {
  slug: PropTypes.string.isRequired,
  leg: PropTypes.number.isRequired,
  render: PropTypes.func.isRequired,
};

Interview.defaultProps = {
  interview: undefined,
};

const mapStateToProps = createStructuredSelector({
  loading: selectLoading,
  error: selectError,
  interview: selectInterview,
});

export default connect(mapStateToProps)(Interview);
